<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="shopitembox">
      <div class="topbox">
        <div class="leftbox">
          <img :src="showsku.skuImage" alt="" />
        </div>
        <div class="rightbox">
          <div class="itemtitle">
            <p>{{ shopitem.prodName }}</p>
            <p class="itemtype">{{ shopitem.typeCodeCn }}</p>
            <p class="itemprice">￥{{ price2 }}</p>

            <p class="skutype1" v-if="showsku1box">选择{{ sku1Text }}</p>
            <div class="allskubox" v-if="showsku1box">
              <div
                class="skubox"
                v-for="item2 in this.uniqueSku1List"
                :key="item2.id"
                @click="chooseSku1(item2.id)"
                @mouseover="showSkuText(item2.id)"
                @mouseleave="hideSkuText()"
                :class="{ choosebox: chooseSku1Value == item2.skuValue1 }"
              >
                <img :src="item2.skuImage" alt="" />
                <div class="skunamebox">
                  <p>{{ item2.skuValue1 }}</p>
                </div>
              
              </div>
            </div>

            <p class="skutype1" v-if="showsku2box">选择{{ sku2Text }}</p>
            <div class="allskubox" v-if="showsku2box">
              <div
                class="skubox skubox2"
                v-for="item2 in this.uniqueSku2List"
                :key="item2.id"
                @click="chooseSku2(item2.id)"
                @mouseover="showSku2Text(item2.id)"
                @mouseleave="hideSku2Text()"
                :class="{ choosebox2: chooseSku2Value == item2.skuValue2 }"
              >
                <div class="skunamebox skunamebox2">
                  <p>{{ item2.skuValue2 }}</p>
                </div>
                
              </div>
            </div>
          </div>
          <div class="buyitem">
           <a href="javascript:void(0)" @click="GotoBuy()" >
              <span>购买</span>
            </a>  
            <!-- <router-link :to="`/shopbuy/${shopitem.id}`">
              购买
            </router-link> -->
          </div>
        </div>
      </div>

      <div class="midbox">
        <div class="midboxtitle">
          <p>商品详情</p>
        </div>
        <div class="skudes" v-html="shopitem.prodContent"></div>
      </div>
    </div>
    　
    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "./../assets/less/global.css";
export default {
  name: "shopdes",
  data() {
    return {
      showpos2: false,
      shopitem: {},
      price2: 0,
      currentHoverId: null, // 当前悬停图片的 ID
      currentHoverId2: null, // 当前悬停图片的 ID
      showsku1box: false,
      showsku2box: false,
      sku1Text: "",
      sku2Text: "",
      chooseSku1Value: null,
      chooseSku2Value: null,
      showsku: {},
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {
  

    // 对 skuList 中的 skuValue1 去重
    uniqueSku1List() {
      const seenValues = new Set();
      if (this.shopitem != null && this.shopitem.skuList != null) {
        return this.shopitem.skuList.filter((item) => {
          const key = item.skuValue1;
          if (seenValues.has(key)) {
            return false;
          }
          seenValues.add(key);
          return true;
        });
      }
    },
    uniqueSku2List() {
      const seenValues = new Set();
      if (this.shopitem != null && this.shopitem.skuList != null) {
        // console.log("uniqueSku2List");
        return this.shopitem.skuList.filter((item) => {
          if (this.chooseSku1Value == item.skuValue1) {
            const key = item.skuValue2;
            if (seenValues.has(key)) {
              return false;
            }
            seenValues.add(key);
            return true;
          } else {
            return false;
          }
        });
      }
    },
  },
  methods: {
      GotoBuy() {
        // console.log(this.showsku);
        // console.log(this.showsku.id);
      this.token = localStorage.getItem("token");
      if (!this.token) {
        alert("请先登录");
         this.$router.push({
          name: "regPage",
        });
      } else {
        this.$router.push({
           name: "shopbuy",
          params: {
          id: this.shopitem.id,
          sku: this.showsku.id,
        },
        });
      }
    },
    showSkuText(id) {
      // console.log("showSkuText=" + id);
      this.shopitem.skuList.forEach((element) => {
        if (element.id == id) {
          if (element.skuValue1.length > 0) {
            this.currentHoverId = id;
          }
        }
      });
    },
    // 鼠标移开时清空当前 ID
    hideSkuText() {
      this.currentHoverId = null;
    },

    showSku2Text(id) {
      // console.log("showSkuText=" + id);
      this.shopitem.skuList.forEach((element) => {
        if (element.id == id) {
          if (element.skuValue1.length > 0) {
            this.currentHoverId2 = id;
          }
        }
      });
    },
    // 鼠标移开时清空当前 ID
    hideSku2Text() {
      this.currentHoverId2 = null;
    },

    chooseSku1(id) {
      this.chooseSku2Value = null;
      this.shopitem.skuList.forEach((element) => {
        if (element.id == id) {
          if (element.skuValue1 != this.chooseSku1Value) {
            this.chooseSku1Value = element.skuValue1;
            if (element.skuValue2.length > 0) {
              if (this.chooseSku2Value == null) {
                this.chooseSku2Value = element.skuValue2;
                this.showsku = element;
                this.price2 = element.price;
              }
            } else {
              this.showsku = element;
              this.price2 = element.price;
            }
          }
        }
      });
    },
    chooseSku2(id) {
      this.shopitem.skuList.forEach((element) => {
        if (element.id == id) {
          if (element.skuValue2 != this.chooseSku2Value) {
            this.chooseSku2Value = element.skuValue2;
            this.showsku = element;
            this.price2 = element.price;
          }
        }
      });
    },

    async CheckShopitemList() {
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          id: this.shopid,
        };

        const url = "https://ttserver.aizhuotice.online/api/v1/ttProd/SKU";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response.code);
        if (this.response.code == 200) {
          // console.log(this.response.data);
          this.shopitem = this.response.data;
          console.log(this.shopitem);
          this.showsku = this.shopitem.skuList[0];
          this.price2 = this.shopitem.skuList[0].price;
          this.shopitem.skuList.forEach((element) => {
            if (element.skuValue1.length > 0) {
              this.showsku1box = true;
              if (this.chooseSku1Value == null) {
                this.chooseSku1Value = element.skuValue1;
              }
              this.sku1Text = element.skuKey1;
            } else {
              this.showsku1box = false;
            }
            if (element.skuValue2.length > 0) {
              this.showsku2box = true;
              if (this.chooseSku2Value == null) {
                this.chooseSku2Value = element.skuValue2;
              }
              this.sku2Text = element.skuKey2;
            } else {
              this.showsku2box = false;
            }
          });
        } else {
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
  },
  mounted() {
    this.shopid = this.$route.params.id;
    console.log(this.shopid);
    this.CheckShopitemList();
  },
  created() {
    //  console.log(this.$route.params);
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.shopitembox {
  width: 100vw;
  left: 0vw;
  height: auto;
  position: relative;
  background-color: #181818;
  padding-top: 3vw;
}

.topbox {
  width: 90vw;
  left: 5vw;
  height: 40vw;
  position: relative;
  display: flex;
}
.leftbox {
  width: 45vw;
  height: 100%;
  position: relative;
}
.leftbox img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 按比例缩放并裁剪 */
}
.rightbox {
  width: 45vw;
  height: 100%;
  position: relative;
}
.itemtitle {
  width: 100%;
  height: auto;
  position: relative;
  font-size: 1.8vw;
  color: #fff;
  text-align: left;
  /* line-height: 4vw; */
}
.itemtitle p {
  line-height: 2vw;
}
.itemtitle .itemtype {
  font-size: 1.2vw;
  color: #fff;
  text-align: left;
  line-height: 4vw;
  color: #8f8f8f;
}

.allskubox {
  position: relative;
  width: 100%;
  height: 5vw;
  display: flex;
  align-items: left;
  justify-content: left;
  margin-top: 0.5vw;
  gap: 1vw;
  margin-bottom: 0.1vw;
}
.skubox {
  width: 5vw;
  height: 5vw;
  position: relative;
  display: inline-block;
}
.allskubox .choosebox {
  border: 2px solid #fff;
  border-radius: 0.5vw;
  overflow: hidden;
}
.skubox img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 按比例缩放并裁剪 */
  border-radius: 0.5vw;
}
.hover-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  opacity: 1;
  transition: opacity 0.3s ease;
  width: 100%;
  text-align: center;
}
.skunamebox {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  height: 1.3vw;
  width: 100%;
  bottom: 0vw;
  font-size: 1.2vw;
  text-align: center;
  line-height: 1.3vw;
}
.skunamebox p {
  line-height: 1.3vw;
}
.skutype1 {
  font-size: 1.5vw;
  margin-top: 1vw;
}
.buyitem {
  margin-top: 3vw;
  width: 100%;
  height: 3vw;
  position: relative;
  background-color: #a82024;
  color: #fff;
  font-size: 1.5vw;
  text-align: center;
  line-height: 3vw;
}
.buyitem a {
  color: #fff;
  text-decoration: none;
}
.midbox {
  margin-top: 3vw;
  border-top: 6px solid #a82024;
  width: 90vw;
  left: 5vw;
  height: auto;
  position: relative;
  background-color: #181818;
  padding-top: 1vw;
  color: #fff;
}
.midboxtitle {
  width: 100%;
  height: 3vw;
  position: relative;
  /* background-color: #a82024; */
  font-size: 1.8vw;
  text-align: center;
  line-height: 3vw;
}
.skudes {
  position: relative;
  margin-top: 1vw;
  font-size: 1.3vw;
  font-weight: normal;
}

.skubox2 {
  width: 4vw;
  height: 2vw;
}
.allskubox .choosebox2 {
  border-radius: 0.5vw;
  overflow: hidden;
  border: 0px solid #fff;
  background-color: #ff0000;
}

.allskubox .skubox2 {
  height: 2vw;
  bottom: 0vw;
  font-size: 1.2vw;
  border-radius: 0.5vw;
  border: 2px solid #aaa;
}
.skunamebox2 {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  height: 2vw;
  width: 100%;
  bottom: 0vw;
  font-size: 1.2vw;
  text-align: center;
  line-height: 2vw;
  border-radius: 0.5vw;
}
.skunamebox2 p {
  line-height: 2vw;
}
</style>



// WEBPACK FOOTER //
// src/components/shopdes.vue